import React from 'react';
import { Route } from 'react-router-dom';

export const HomeRoute = ({ component: Component, componentProps, ...rest }) => {
    return (
        <Route {...rest} render={() => (
            <Component { ...{...componentProps } } home />
        )} />
    );
};